import { Pipe, PipeTransform } from '@angular/core';
import { AppModes } from '@shared/services/app.service';
import { UserTypes } from '@shared/types/api-types';

@Pipe({
  name: 'appModeTitle',
})
export class AppModeTitlePipe implements PipeTransform {
  transform(mode: AppModes): string {
    switch (mode) {
      case 'CLIENT':
        return $localize`Госпиталь`;
      case 'DISTRIBUTOR':
        return $localize`Дистрибьютор`;
      case 'PRODUCER':
        return $localize`Производитель`;
      default:
        return '';
    }
  }
}
